import api from 'api'
import {
  DayforceShiftAssociationType,
  DayforceShiftType,
} from 'pages/Dayforce/constants'

export type DayforcePendingContestedHoursRequest = {
  id: string
  requestedStartedAt: string
  requestedFinishedAt: string
  requestedBreakDuration: number | null
  requestedReason: string
}

export type DayforceJobWorker = {
  dayforceWorkerId: string
  dayforceShiftId: string
  userId: number
  shiftType: DayforceShiftType
  associationId: number
  startedAt: string | null
  completedAt: string | null
  approvedBreakDuration: number | null
  noShowNoCall: boolean
  pendingContestedHoursRequest: DayforcePendingContestedHoursRequest | null
}

export type DayforceJobRequestedWorkerReason = {
  id: string
  name: string
}

export type DayforceJobRequestedWorker = {
  id: string
  name: string
  worker_id: string
  user_id: number | null
}

export type DayforceJobShift = {
  id: number
  associationType: DayforceShiftAssociationType
}

export type DayforceJobBooking = {
  bookingId: string
  jobName: string | null
  hazmatOldBookingId: string | null
  suggestedShiftId: number | null
  companyId: number | null
  startsAt: string
  finishesAt: string
  dressCode: string | null
  specialInstructions: string
  additionalTasks: string
  position: {
    id: string
    name: string
  }
  level: {
    id: string
    name: string
  }
  workersAssigned: number
  workersRequired: number
  backupWorkersAssigned: number
  backupWorkersRequired: number
  billRate: number
  payRate: number
  bonus: number
  travelStipend: number
  workers: DayforceJobWorker[]
  requested_worker_reasons: DayforceJobRequestedWorkerReason[]
  requested_workers: DayforceJobRequestedWorker[]
  shifts: DayforceJobShift[]
}

export type DayforceJobManager = {
  id: string
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  primaryContact: boolean
  booker: boolean
}

export type DayforceJobDetail = {
  jobId: string
  jobStatus: string
  agencyId: string
  clientId: string
  clientName: string
  bookings: DayforceJobBooking[]
  managers: DayforceJobManager[]
}

export const getDayforceJob = async (
  agencyId: string,
  jobId: string
): Promise<DayforceJobDetail> => {
  const response = await api.get<DayforceJobDetail>(
    `/admin/dayforce/job/${agencyId}/${jobId}`
  )
  return response.data
}
